<template>
  <b-modal
    v-model="modalOpen"
    centered
    title="معلومات النشاط"
    footer-class="removed"
    id="activityModal"
    class="edit-modal"
    no-close-on-backdrop
  >
    <b-card-text>
      <validation-observer ref="activityValidation">
        <b-form @submit.prevent="onSubmit">
          <b-row>
            <b-col cols="12">
              <form-input rules="required" label="الاسم" v-model="form.name" />
            </b-col>
            <!-- <b-col cols="12">
              <form-select
                label="نوع النشاط"
                rules="required"
                v-model="form.activity_type"
                :reduce="(x) => x.id"
                :getOptionLabel="(x) => x.name"
                :options="options"
                id="activity-types"
              />
            </b-col> -->
            <b-col cols="12">
              <form-textarea
                rules="required"
                label="الأهداف"
                v-model="form.objectives"
              />
            </b-col>
            <b-col v-if="showProgramsSelect" cols="12">
              <form-select
                rules="required"
                label="البرنامج"
                id="program"
                v-model="form.program_id"
                :reduce="(x) => x.id"
                :getOptionLabel="(x) => x.name"
                ep="/v2/selects/programs"
                @input="touched = true"
              />
            </b-col>
            <b-col cols="12">
              <form-select
                v-if="activityType"
                multiple
                rules="required"
                label="الخدمات"
                v-model="form.service_ids"
                :reduce="(x) => x.id"
                :getOptionLabel="(x) => x.name_ar"
                :ep.sync="servicesEp"
                ref="servicesSelect"
                id="services-select"
                :closeOnSelect="false"
              />
              <form-select
                v-else
                multiple
                rules="required"
                label="الخدمات"
                v-model="form.service_ids"
                :reduce="(x) => x.id"
                :getOptionLabel="(x) => x.name_ar"
                ep="v2/selects/services"
                ref="servicesSelect"
                id="services-select"
                :closeOnSelect="false"
              />
            </b-col>
            <b-col cols="12">
              <form-select
                multiple
                rules="required"
                label="الفئات المستهدفة"
                id="ageCategory"
                v-model="form.category_ids"
                :reduce="(x) => x.id"
                :getOptionLabel="(x) => x.name_ar"
                ep="/v2/selects/age-categories"
                :closeOnSelect="false"
              />
            </b-col>
          </b-row>
          <hr />

          <b-row class="px-1 justify-content-end">
            <b-button @click="modalOpen = false" class="mx-1">إلغاء</b-button>
            <save-btn
              type="submit"
              variant="primary"
              :loading="loading"
              :label="btnLabel"
            >
            </save-btn>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card-text>
  </b-modal>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BCardTitle,
  BModal,
  BFormGroup,
  BFormRadio,
  BForm,
  BFormTextarea,
  BButton,
} from "bootstrap-vue";
import { ValidationObserver } from "vee-validate";
import formInput from "@/components/form-input";
import formSelect from "@/components/form-select";
import vSelect from "vue-select";
import formTextarea from "@/components/form-textarea";
import saveBtn from "@/components/loader-btn";
import formDatepicker from "@/components/form-datepicker";
import { required, integer } from "@validations";
import FormTextarea from "@/components/form-textarea/index.vue";

const initForm = {
  // program_type: null,
};
export default {
  components: {
    formInput,
    formTextarea,
    formSelect,
    BButton,
    formDatepicker,
    saveBtn,
    vSelect,
    BRow,
    BCol,
    BCard,
    BCardText,
    BCardTitle,
    BModal,
    BFormGroup,
    BForm,
    BFormRadio,
    BFormTextarea,
    ValidationObserver,
    FormTextarea,
  },
  props: {
    value: Boolean,
    title: String,
    btnLabel: String,
    loading: Boolean,
    intializeForm: {
      type: Object,
      default: () => initForm,
    },
    activityType: Boolean,
  },
  data() {
    return {
      form: {},
      required,
      integer,
      servicesEp: "v",
      touched: false,
    };
  },
  computed: {
    modalOpen: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
    showProgramsSelect() {
      return this.activityType;
    },
  },
  watch: {
    modalOpen(val) {
      if (val) this.init(this.intializeForm);
    },
    "form.program_id"(val) {
      if (this.touched) this.$set(this.form, "service_ids", []);
      if (val) {
        this.servicesEp = "v2/selects/program-services/" + val;
        this.$nextTick(() => {
          this.$refs.servicesSelect.refreshOptions(this.servicesEp);
        });
      }
    },
  },

  methods: {
    init(form) {
      this.form = JSON.parse(JSON.stringify(form));
    },
    async onSubmit() {
      await this.$refs.activityValidation.validate().then(async (success) => {
        if (success) {
          this.$emit("confirm", this.form);
        }
      });
    },
  },
};
</script>
